module.exports = __webpack_public_path__ + "static/media/2.ccc55589.JPG";